class SwipeCarousel extends HTMLElement {
    static observedAttributes = ["media"];

    constructor() {
        super();
        this.items = Array.from(this.querySelectorAll('.c-carousel-item'))
        
        this.layout = this.querySelector('.c-carousel-layout')
    }


    /*
    * Two items
    */
    updateDots(onLoad = false) {

            const carousel_items = this.shadowRoot.querySelectorAll(".c-carousel-item")
    
            const options = {
                root: this.querySelector(".c-carousel-layout"),
                rootMargin: "0px",
                scrollMargin: "0px",
                threshold: [0.50],
            };
            const callback = (entries, observer) => {
               
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        if (entry.intersectionRatio > 0.50) {
                            let elem = entry.target;
                            let index = Array.from(carousel_items).findIndex((item => item == elem)) 
           
                             this.shadowRoot.querySelector('span[style="background-color: black;"]')?.removeAttribute('style')
                             onLoad ? this.dots[0].style.backgroundColor = 'black' : this.dots[index].style.backgroundColor = 'black'
                 
                        } 
                    }
                });
                onLoad = false
            }
            const observer = new IntersectionObserver(callback, options);
            carousel_items.forEach((item) => {
                observer.observe(item);
            })
    }

    


    addEventListeners() {
        this.shadowRoot.querySelector('.carousel-item-count')?.addEventListener('click', (e) => {
            if (e.target.tagName !== 'SPAN') return;
            const index = Array.from(e.target.parentNode.children).indexOf(e.target)
            this.items[index].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        })
    }

    render(media) {
        let image_count = media.length
        this.shadowRoot.innerHTML = `
        <link href="/cdn/shop/t/521/assets/swipe-carousel.css?v=18893498944859967451759949052" rel="stylesheet" type="text/css" media="all">
         <!-- Images -->
        <div class="c-carousel-layout">
                ${ media.map((img) => {
                    return (
                        `<div class="c-carousel-item">
                                <img width="355" src="${img.preview.image.url}" alt="dimensions image">
                        </div>`
                    )
                }).join('')}
        </div>
        <!-- Dots under images -->
        ${(() => {
            if(image_count > 1) {
                return (
                    `<div class="carousel-item-count" data-count-many="${image_count > 25 ? true : false}">
                        ${ media.map(img => `<span></span>`).join('')}
                    </div>`
                )
            }
        })()}`;
    }


    attributeChangedCallback(media, oldValue, newValue) {
        const shadow = this.attachShadow({ mode: 'open' });
        if (oldValue !== newValue) {
            const media = JSON.parse(newValue)
            // media attribute is changed 
            if (media.length) {
                this.render(media)
                this.items = Array.from(shadow.querySelectorAll('.c-carousel-item'))
                this.dots = shadow.querySelectorAll('.carousel-item-count span')
                this.addEventListeners(shadow)
                this.updateDots(onload=true)
            } 
        }
    }

    connectedCallback() {
        if(!this.items[0]) return;

        this.addEventListeners()
        if (this.dots[this.current]) this.dots[this.current].style.backgroundColor = 'black'
        this.previous_inview_index = this.current

    }
}
customElements.define('swipe-carousel', SwipeCarousel);



